module.exports = __webpack_public_path__ + "static/media/RKProjectPrevieww1870@2x.e92e1f6a.webp";